import { SwitchNum, Second, SwitchString } from '../../';

export interface IUserAccount {
    id: string;
    umu_id: string;
    account: string;
    account_type: 'user';
    user_name: string;
    avatar: string;
    email?: string;
    login_name?: string;
}
export interface IGroupAccount {
    id: string;
    account: string;
    account_type: 'group';
    group_name: string;
}
export interface IClassAccount {
    id: string;
    account: string;
    account_type: 'class';
    class_name: string;
}
export interface IDepartmentAccount {
    id: string;
    account: string;
    account_type: 'department';
    department_name: string;
    department_id: string;
}

export interface ITeamUser {
    umu_id: string;
    user_name: string;
    avatar: string;
}

type IDELETE_UNU_IDS = { delete_umu_ids?: string[] };
type IACCOUNT_USER = { users?: ITeamUser[]; member_id?: string };

export type IAccountGroup = IGroupAccount & IDELETE_UNU_IDS & IACCOUNT_USER;
export type IAccountClass = IClassAccount & IDELETE_UNU_IDS & IACCOUNT_USER;
export type IAccountDepartment = IDepartmentAccount & IDELETE_UNU_IDS & IACCOUNT_USER;
export type IAccount = (IUserAccount & IACCOUNT_USER) | IAccountGroup | IAccountClass | IAccountDepartment;
export interface ITeam {
    id: string;
    team_name: string;
    accounts: IAccount[];
    user_count?: number;
    temporary_id?: string; // 前端临时生成的 id
    all_users?: ITeamUser[]; // 前端展示用, 不传给后端
}

export enum EMETRICS_TYPE {
    course_points_metrics = 'course_points_metrics',
    course_points_reach_metrics = 'course_points_reach_metrics',
    course_points_excellent_metrics = 'course_points_excellent_metrics',
    course_points_positive_metrics = 'course_points_positive_metrics',
    course_points_recognition_metrics = 'course_points_recognition_metrics',
    exam_metrics = 'exam_metrics',
    homework_metrics = 'homework_metrics',
    course_complete_metrics = 'course_complete_metrics',
}

export enum EALGORITHM {
    average_score = '1',
    total_score = '2',
}

export enum EHOMEWORK_METRICS {
    homework_metrics_ai_expressive = 'homework_metrics_ai_expressive',
    homework_metrics_ai_keyword_evaluation = 'homework_metrics_ai_keyword_evaluation',
    homework_metrics_teacher = 'homework_metrics_teacher',
    homework_metrics_student = 'homework_metrics_student',
    homework_metrics_ai_gesture_practice = 'homework_metrics_ai_gesture_practice',
}

// PK指标
export interface IMetricsSetting {
    type: EMETRICS_TYPE;
    selected: SwitchString;
    algorithm: EALGORITHM;
    session_ids?: string[];
    sub_types?: EHOMEWORK_METRICS[];
}

//活动时间节点
export enum EMILESTONE {
    create = '1',
    start = '2',
    end = '3',
}

export interface IPKDetail {
    id: string; // pk id
    course_id: string;
    activity_name: string;
    start_time: Second;
    end_time: Second;
    can_delete: SwitchNum;
    creator_umu_id: string;
    metrics_settings: IMetricsSetting[];
    notification_settings: {
        milestone: EMILESTONE[];
        reminder: string[]; // 到期前提醒
        switch: '0' | '1'; // 开启邮件
    };
}

export enum EACTIVITY_STATUS {
    not_start = '1',
    doing = '2',
    end = '3',
}

export interface IMetricsSession {
    session_id: string;
    session_title: string;
    homework_type: string;
    session_url?: string;
    pc_session_url?: string;
}

export type EONE_DIMENSIONAL_METRICS = EMETRICS_TYPE | EHOMEWORK_METRICS;

export interface IPKListItemMetrics {
    type: EONE_DIMENSIONAL_METRICS;
    algorithm: EALGORITHM;
}
export interface IPKListItem {
    id: string;
    activity_name: string;
    activity_status: EACTIVITY_STATUS;
    start_time: Second;
    end_time: Second;
    creator_umu_id: string;
    creator_user_name: string;
    team_number: number;
    can_delete: SwitchNum;
    metrics_settings: IPKListItemMetrics[]; // sub_type 被打平到一维
}

export interface IUserRank {
    avatar: string;
    umu_id: string;
    user_name: string;
    ranking: number;
    metrics_value: number;
    update_ts: Second;
}
export interface IPKTeamLeaderboardData {
    id: string;
    team_name: string;
    user_count: number;
    ranking: number;
    update_ts: Second;
    metrics_value: number; // 分数
    manual_value: number; // 历史加减分
    user_list: IUserRank[];
    owner?: IUserRank; // 自己的排名
}
